const logoStyle = {
    logosized: {
        maxWidth: "10px",
    }
};

export default logoStyle;